export default function IntercomWrapper(...rest) {
  // only send to IntercomWrapper if we're on prod
  if (process.env.REACT_APP_FE_ENV === 'prod' && window.location === window.parent.location) {
    setTimeout(() => window.Intercom(...rest));
  } else {
    // eslint-disable-next-line no-console
    console.warn('Would have called intercom with', rest);
  }
}
